import React from 'react'
import { Modal } from 'react-bootstrap'
import ReactLoading from 'react-loading'


const ModalComponent = ({
    callbackParent,
    component=null,
    confirm = false,
    icon = null,
    show = true,
    size = 'sm',
    title = null,
    variant = 'success'
}) => {

    const getIcon = (icon) => {
        const icons = {
            success: 'fa-check-circle',
            info: 'fa-info-circle',
            warning: 'fa-exclamation-triangle',
            danger: 'fa-times-circle'
        }

        return icons[icon] || icons.info
    }

    const ConvertContent = ({ component }) => {
        return <>{component}</>
    }


    return (
        <>

            <Modal
                backdrop="static"
                className='modal fade'
                // onHide={handleClose}
                show={show}
                size={size}
                centered
                keyboard={false}
                tabindex="-1"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {
                            icon ?
                                <i
                                    class={`fas ${getIcon(icon)} fa-lg color-${icon} mr-2`}
                                    aria-hidden='true'
                                ></i>
                                : null
                        }
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={!component ? 'mx-auto' : null}>
                    {
                        component ?
                            <ConvertContent component={component} />
                            : <ReactLoading
                                className='modal-loading text-center'
                                type='spinningBubbles'
                                color='#071d41'
                            />
                    }
                </Modal.Body>

                {
                    confirm ? (
                        <Modal.Footer>
                            {confirm == true ?
                                <>
                                    <button
                                        className='close'
                                        onClick={this.props.state.onHide}
                                        size='sm'
                                    >Não</button>

                                    <button
                                        className='action'
                                        size='sm'
                                    >Sim</button>
                                </>
                                :
                                <button
                                    className='close'
                                    onClick={this.props.state.onHide}
                                    size='sm'
                                >Fechar</button>
                            }
                        </Modal.Footer>
                    ) : null
                }

            </Modal>
        </>
    )

}

export default ModalComponent;




